import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { useAuth } from "../../context/AuthContext";
import Tooltip from "@mui/material/Tooltip";
import AdminLeftMenu from "./AdminLeftMenu";
import { functions, httpsCallable } from "../../firebase";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";

import {
  db,
  collection,
  orderBy,
  getDocs,
  query,
  addDoc,
} from "../../firebase";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { useConfirm } from "material-ui-confirm";
import AdminCheck from "./AdminCheck";

function timeConverter(UNIX_timestamp) {
  var a = new Date(UNIX_timestamp * 1000);
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time =
    month + " " + date + " " + year + " " + hour + ":" + min + ":" + sec;
  return time;
}

const AdminDashboard = () => {
  const confirm = useConfirm();
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [payments, setPayments] = useState([]);
  const getBalances = httpsCallable(functions, "getBalances");
  const getTransactions = httpsCallable(functions, "getTransactions");
  const getPaymentInfoWithPaymentIntent = httpsCallable(
    functions,
    "getPaymentInfoWithPaymentIntent"
  );
  const createAddress = httpsCallable(functions, "createAddress");

  useEffect(() => {
    const test = async () => {
      const result = await createAddress();
      console.log(result);
    };
    test();
  }, []);

  useEffect(() => {
    const getFinance = async () => {
      try {
        const result = await getBalances();
        setBalance(result.data);
        // console.log(result.data);
      } catch (error) {
        // console.log(error);
      }
    };
    getFinance();
    const getTransaction = async () => {
      try {
        const result = await getTransactions();
        setTransactions(result.data.data);
        // console.log("transactions", result.data);
        // console.log("transactions", result.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getTransaction();
    const getPayments = async () => {
      setLoading(true);
      setPayments([]);
      const q = query(collection(db, "US_orders"), orderBy("created", "asc"));
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach(async (doc) => {
        // console.log(doc.id, " => ", doc.data());
        if (doc.data().payment_intent) {
          // console.log(doc.data().address_firstname);
          try {
            const result = await getPaymentInfoWithPaymentIntent({
              pi: doc.data().payment_intent,
            });
            // console.log("payments===", result.data);
            setPayments((old) => [
              ...old,
              {
                ...result.data,
                firstname: doc.data().address_firstname,
                lastname: doc.data().address_lastname,
              },
            ]);
          } catch (error) {
            console.log(error);
          }
        }
      });
      setLoading(false);
    };
    getPayments();
  }, []);

  const sendReceipt = async (receipt_email, receipt_url) => {
    try {
      await addDoc(collection(db, "mail"), {
        to: receipt_email,
        message: {
          subject: "Heslet - Order Receipt",
          html: `<!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Thank you!</title><style>
                @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
                .myDiv {
                    font-family: 'Roboto', sans-serif;
                  border: 1px solid lightgray;
                  width:400px;
                 margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
                 padding-left:20px; padding-right:20px; line-height: 1.8em;
                }
                .logo{display:flex;  justify-content: space-between;}
                .confirm{top:+40px;position:relative}
                .blue{color:#153a5a; font-weight: bold;}
                .hello{padding-top:30px}
                .detail{padding-top:30px;border-bottom:1px solid lightgray;}
                .order{padding-top:20px}
                .green{color:#689f38}
                .custom_btn{background-color: #153a5b;cursor:pointer;
          color: white;
          letter-spacing: 3px;
          border-radius: 0;
          width: 100%;
          border: none;
          text-transform: uppercase;
          padding-top: 15px;
          padding-bottom: 15px;
          cursor: pointer;}
            .button{padding-top:20px}
            .ship{padding-top:20px}
            .Recommendations{padding-top:40px}
            .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
            .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
            justify-content: space-evenly;}
            .custom_btn_whitebg {
          border: 1px #212a2f solid;
          color: black;
          letter-spacing: 3px;
          border-radius: 0;
          width: 100%;
          border: none;
          text-transform: uppercase;
          padding-top: 15px;
          padding-bottom: 15px;
          cursor: pointer;
        }
              </style>
        </head>
        <body>
            <div class="myDiv">
                <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
                <div class="confirm" style="padding-top:50px; padding-left:30px;">Heslet - Order Receipt</div></div>
                <br />
                <div class="blue hello">Hello,</div>
                <br />Thank you for purchsing with Heslet. Here is your receipt.
                <div>Link: ${receipt_url} </div> 
                <div class="button"><a href="http://localhost:3007/products-cleansing"><button class="custom_btn">our products</button></a></div>
                <div class="button"><a href="http://localhost:3007/products-cleansing"><button class="custom_btn_whitebg">Our Technology</button></a></div>
                <div class="Recommendations">
                     Recommendations for items from across our store
                </div>
                <div class="recomm">
                    <div class="each" style="padding-right:30px;">
                        <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
                        <div>Premium Heavy Duty<br /> Hand Wipes</div>
                    </div>
                    <div class="each" style="padding-right:30px;">
                        <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
                        <div>Premium<br /> All-Purpose Wipes</div>
                    </div>
                    <div class="each">
                        <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
                        <div>Premium <br />All Purpose Spray</div>
                    </div>
                </div>
                <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
            </div>
        </body>
        </html>`,
        },
      }).then((res) => {});
    } catch (error) {
      alert("There is a technical issue with sending an email. Try later.");
    }
  };

  const handleConfirm = (msg, action, receipt_email, receipt_url) => {
    confirm({ description: msg })
      .then(() => {
        if (action === "receipt") {
          sendReceipt(receipt_email, receipt_url);
        }
      })
      .catch(() => {
        /* ... */
      });
  };

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9.5} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%", pb: 10 }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px" }}>
                  Finances{" "}
                  <span style={{ fontSize: "14px" }}>
                    (This page will take some time to load)
                  </span>
                </Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  View Details Stats
                </Box> */}
              </Box>

              <Grid container spacing={2}>
                <Grid item md={6} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      backgroundColor: "white",
                      minHeight: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>Stripe Account Balance</Box>
                      <Box className="pink_link" sx={{ fontSize: "13px" }}>
                        {/* You have {products.length} products */}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        py: 3,
                        px: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ fontSize: "14px", textAlign: "center" }}>
                        <PaidOutlinedIcon
                          sx={{ position: "relative", top: "+6px" }}
                        />{" "}
                        Available Balance:{" "}
                        {balance?.available.map((bal) => {
                          // console.log(bal);
                          return (
                            <>
                              <span style={{ color: "#274866" }}>
                                {bal.currency === "usd" ? "$" : null}{" "}
                                {bal.amount / 100} ({bal.currency.toUpperCase()}
                                )
                              </span>

                              <Box sx={{ pt: 1, fontSize: "14px" }}>
                                Payment Method{" "}
                                <>
                                  <span style={{ color: "#274866" }}>
                                    Card Processing: ${" "}
                                    {bal.source_types.card / 100}
                                  </span>
                                </>
                              </Box>
                            </>
                          );
                        })}
                        <Box sx={{ pt: 1 }}>
                          <PendingOutlinedIcon
                            sx={{ position: "relative", top: "+6px" }}
                          />{" "}
                          Pending Balance:{" "}
                          <>
                            {balance?.pending.map((pen) => {
                              // console.log("pen", pen);
                              return (
                                <>
                                  {pen.currency === "usd" ? "$" : null}{" "}
                                  {pen.amount / 100}
                                </>
                              );
                            })}
                          </>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "11px",
                            pt: 1,
                            borderTop: "1px solid lightgray",
                            mt: 3,
                            pt: 3,
                            lineHeight: "1.9em",
                          }}
                        >
                          The charged amount, less any Stripe fees, is initially
                          reflected on the pending balance, and becomes
                          available on a{" "}
                          <span className="pink_link">2-day rolling basis</span>
                          . (This timing can vary by country and account.)
                          Available funds can be paid out to a bank account or
                          debit card.
                        </Box>
                        <Box sx={{ pt: 1, lineHeight: "1.9em" }}>
                          <a
                            href="https://dashboard.stripe.com/dashboard"
                            target="_blank"
                            rel="noreferrer"
                            className="pink_link"
                            style={{ fontSize: "14px" }}
                          >
                            Stripe Dashboard
                          </a>
                          <br />
                          <a
                            href="https://stripe.com/docs/disputes/responding"
                            target="_blank"
                            rel="noreferrer"
                            className="pink_link"
                            style={{ fontSize: "14px" }}
                          >
                            Stripe Credit Card Dispute concepts
                          </a>

                          <br />
                          <a
                            href="https://support.stripe.com/questions/common-questions-about-payout-schedules"
                            target="_blank"
                            rel="noreferrer"
                            className="pink_link"
                            style={{ fontSize: "14px" }}
                          >
                            Stripe Support
                          </a>
                          <br />
                          <a
                            href="https://stripe.com/docs/refunds#dashboard"
                            target="_blank"
                            rel="noreferrer"
                            className="pink_link"
                            style={{ fontSize: "14px" }}
                          >
                            How to issue a refund through stripe dashboard
                          </a>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={6} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      backgroundColor: "white",
                      minHeight: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "13px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        Stripe Credit Card Transactions ({payments?.length})
                      </Box>
                      <Box className="pink_link" sx={{ fontSize: "12px" }}>
                        All Transactions
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        py: 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: 1,
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: "13px",
                          textAlign: "left",
                          width: 1,
                        }}
                      >
                        <Box sx={{ px: 4 }}>
                          {payments.map((pay) => {
                            // console.log("pay", pay);
                            return (
                              <Box sx={{ pb: 2 }}>
                                <PointOfSaleOutlinedIcon
                                  sx={{
                                    color: "gray",
                                    position: "relative",
                                    top: "+4px",
                                    pr: 1,
                                    fontSize: "13px",
                                  }}
                                />
                                {pay.firstname} {pay.lastname}{" "}
                                <span
                                  style={{
                                    fontSize: "13px",
                                    color: "#757575",
                                  }}
                                >
                                  {timeConverter(pay.created)}
                                </span>
                                <Box
                                  sx={{
                                    fontSize: "12px",
                                    px: 2,
                                    paddingTop: "4px",
                                  }}
                                >
                                  Amount: ${pay.amount_received / 100}, Status:{" "}
                                  <span style={{ color: "#4db6ac" }}>
                                    {pay.status}
                                  </span>
                                  ,
                                  {pay.charges.data.map((ch) => {
                                    console.log(ch);
                                    return (
                                      <span>
                                        {" "}
                                        <a
                                          href={ch.receipt_url}
                                          rel="noreferrer"
                                          target="_blank"
                                        >
                                          <ReceiptLongOutlinedIcon
                                            sx={{
                                              fontSize: "14px",
                                              position: "relative",
                                              top: "+2px",
                                            }}
                                          />{" "}
                                          <span className="pink_link">
                                            Receipt
                                          </span>
                                        </a>
                                        {"  "}
                                        <span
                                          onClick={() =>
                                            handleConfirm(
                                              "Send the receipt to this customer?",
                                              "receipt",
                                              ch.receipt_email,
                                              ch.receipt_url
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          <EmailOutlinedIcon
                                            sx={{
                                              fontSize: "14px",
                                              position: "relative",
                                              top: "+2px",
                                            }}
                                          />{" "}
                                          <span
                                            className="pink_link"
                                            style={{ paddingRight: "5px" }}
                                          >
                                            Send Recipt
                                          </span>
                                        </span>
                                        <a
                                          href={"mailto:" + ch.receipt_email}
                                          rel="noreferrer"
                                          target="_blank"
                                        >
                                          <EmailOutlinedIcon
                                            sx={{
                                              fontSize: "14px",
                                              position: "relative",
                                              top: "+2px",
                                            }}
                                          />{" "}
                                          <span className="pink_link">
                                            Email
                                          </span>
                                        </a>
                                      </span>
                                    );
                                  })}
                                </Box>
                              </Box>
                            );
                          })}
                          {loading && "...Loading. Please wait."}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
// users
